import authApiService from "./userApiService"; // Ensure this is your axios instance with interceptors

const resetTokesService = {
  // Reset all tokes
  async resetAllTokes() {
    try {
      const response = await authApiService.post("/reset-tokes");
      return { success: true, data: response.data };
    } catch (error) {
      return this.handleError(error);
    }
  },

  // Generic error handler
  handleError(error) {
    let errorMessage = "An unexpected error occurred";
    
    if (error.response) {
      // Server responded with a status outside 2xx
      errorMessage = error.response.data?.error || 
                    error.response.data?.message || 
                    `Server error: ${error.response.status}`;
    } else if (error.request) {
      // Request was made but no response received
      errorMessage = "Network error: No response from server";
    } else {
      // Something happened in setting up the request
      errorMessage = error.message || "Request setup error";
    }
    
    console.error("API Error:", errorMessage);
    return { 
      success: false, 
      error: errorMessage,
      status: error.response?.status 
    };
  }
};

export default resetTokesService;